import apiMocks from "./apiMocks.prod";
export default apiMocks;